import React from 'react'
import { useHistory } from 'react-router-dom'
import Cdn from 'utils/assets/Cdn'
import { Button } from '@arvoreeducacao/bonsai-ds'
import { LOGIN_PATH } from 'routes/paths'

export const BookfairSuccess = () => {
  const history = useHistory()

  return (
    <div className="w-screen min-h-screen flex flex-col items-center justify-start py-20 px-4 pb-10 bg-white relative md:py-[100px] md:px-10 md:pb-[60px]">
      <div className="w-full max-w-[610px] mb-8 flex justify-center items-center">
        <img
          src={Cdn.getImageUrl(
            'payment-page/payment-confirmation-celebration.svg'
          )}
          alt="Celebração"
          className="w-full h-auto max-h-[240px]"
        />
      </div>
      <h1 className="text-[24px] md:text-[32px] font-bold text-gray-900 text-center mb-8 max-w-[460px]">
        O aluno já está pronto para usar a Árvore!
      </h1>
      <div className="w-full max-w-[460px] border border-gray-100 rounded-[12px] p-6 mb-8 bg-white shadow-[0px_0px_10px_rgba(0,0,0,0.06)]">
        <p className="text-sm font-normal text-gray-700 leading-5 mb-4 last:mb-0">
          Enviamos as informações de acesso para o o e-mail registrado no
          momento da compra do material didático. Verifique sua caixa de entrada
          e, se necessário, a pasta de spam.
        </p>
        <p className="text-sm font-normal text-gray-700 leading-5 mb-4 last:mb-0">
          Caso não receba o email ou precise de ajuda, entre em contato com{' '}
          <a
            href="mailto:atendimento@arvore.com.br"
            className="text-blue-600 underline cursor-pointer hover:text-blue-700"
          >
            atendimento@arvore.com.br
          </a>
          .
        </p>
      </div>
      <Button
        theme={{ type: 'primaryLivros', size: 'large' }}
        text="Voltar para a página inicial"
        onClick={() => {
          history.push(LOGIN_PATH)
        }}
      />
    </div>
  )
}
